/**
 * Created by vladislav on 17.09.2020
 */

const ProgressView = cc.Node.extend({
    ctor: function () {
        this._super();
        this.setAnchorPoint(0.5, 0.5);
        this.hoverContainer = new cc.Node();
        this.hoverContainer.setAnchorPoint(0.5, 0.5);
        this.addChild(this.hoverContainer);

        this.addProgressBar();
        this.addArrows();
        this.addIcons();
        cleverapps.UI.wrap(this.hoverContainer);
        this.setContentSize2(this.hoverContainer.getContentSize());
        this.hoverContainer.setAlignment(this.width / 2, this.height / 2);

        cleverapps.UI.onClick(this.hoverContainer, this.onClick.bind(this));

        const position = cleverapps.styles.ProgressView.positions || cleverapps.styles.ProgressView;
        this.setAlignment(position);

        this.setCascadeOpacityEnabledRecursively(true);

        cleverapps.aims.registerTarget("locationProgress", this, {
            controls: ["progress_view"],
            flyingAnimation: Reward.JUMP_COLLECT_ANIMATION,
            duration: 1000
        });

        cleverapps.meta.getSelectedLocation().on("nextStage", this.onNextStage.bind(this), this);
        cleverapps.meta.getSelectedLocation().on("showForce", this.showForce.bind(this), this);
        cleverapps.meta.getSelectedLocation().on("updateProgress", this.updateProgress.bind(this), this);

        SceneDecors.add(this.hoverContainer, cleverapps.skins.getSlot("progressViewDecor"));
    },

    onNextStage: function () {
        this.runProgressAnimation();

        this.runAvatarAnimation();
    },

    updateProgress: function () {
        this.progressBar.updateProgress();
    },

    onClick: function () {
        if (cleverapps.forces.isRunningForce()) {
            cleverapps.forces.closeRunningForce();
        }

        cleverapps.effects.fire("ui.button.click");

        if (!cleverapps.config.rpg) {
            cleverapps.focusManager.display({
                stack: true,
                focus: "BackgroundsWindow",
                action: function (f) {
                    new BackgroundsWindow();
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
        }
    },

    showForce: function () {
        cleverapps.focusManager.setEventNodes([this]);
        FingerView.hintTap(this, {
            runOnce: true
        });
    },

    runProgressAnimation: function () {
        const styles = cleverapps.styles.ProgressView;

        const progressBarAnimation = new cleverapps.Spine(bundles.simple.jsons.progress_bar_spark_json);
        this.hoverContainer.addChild(progressBarAnimation);
        progressBarAnimation.setAlignment(styles.bar.spark);
        progressBarAnimation.runAction(new cc.Sequence(
            new cc.DelayTime(0.4),
            new cc.CallFunc(() => {
                progressBarAnimation.setAnimation(0, "animation", false);
                progressBarAnimation.setCompleteListenerRemove();
            })
        ));
    },

    runAvatarAnimation: function () {
        if (cleverapps.config.rpg) {
            return;
        }

        const avatarAnimation = new cleverapps.Spine(bundles.simple.jsons.avatar_spark_json);
        this.hoverContainer.addChild(avatarAnimation);
        avatarAnimation.setAlignment(this.nextIcon.getPosition());
        avatarAnimation.setCompleteListenerRemove();
        avatarAnimation.runAction(new cc.Sequence(
            new cc.DelayTime(0.7),
            new cc.CallFunc(() => {
                avatarAnimation.setAnimation(0, "animation", false);
                cleverapps.effects.fire("location.simple.win");
            })
        ));
    },

    addProgressBar: function () {
        const styles = cleverapps.styles.ProgressView;

        this.progressBar = new StarsProgressBar({
            width: styles.bar.width
        });
        this.hoverContainer.addChild(this.progressBar);
    },

    addArrows: function () {
        const styles = cleverapps.styles.ProgressView.arrows;

        if (!styles) {
            return;
        }

        const arrowWidth = new cc.Sprite(bundles.simple.frames.arrow_png).width;
        const amount = (this.progressBar.width - styles.widthOffset) / (arrowWidth + styles.margin);

        const arrows = [];
        for (let i = 0; i < amount; i++) {
            arrows.push(new cc.Sprite(bundles.simple.frames.arrow_png));
        }

        const layout = new cleverapps.Layout(arrows, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });

        layout.setLocalZOrder(-1);

        this.progressBar.bar.addChild(layout);
        layout.setAlignment(styles);
    },

    addIcons: function () {
        if (cleverapps.config.rpg) {
            return;
        }

        const styles = cleverapps.styles.ProgressView;

        const location = cleverapps.meta.getSelectedLocation();

        const currentIcon = this.currentIcon = this.createIcon();
        this.hoverContainer.addChild(currentIcon);
        currentIcon.setAlignment(-styles.bar.width / 2 - styles.icon.offset.x, this.height / 2 + styles.icon.offset.y);
        currentIcon.setRotation(-styles.icon.rotation || 0);

        const nextIcon = this.nextIcon = this.createIcon(true);
        nextIcon.setRotation(styles.icon.rotation || 0);
        this.hoverContainer.addChild(nextIcon);
        nextIcon.setAlignment(styles.bar.width / 2 + styles.icon.offset.x, this.height / 2 + styles.icon.offset.y);
        if (location.isComingSoonStage(location.getStage())) {
            nextIcon.addChild(this.createLock());
        }
    },

    createIcon: function (isNext) {
        const location = cleverapps.meta.getSelectedLocation();

        let icon;
        if (isNext) {
            icon = new cc.Sprite(bundles[location.getIconBundle(location.getStage() + 1)].urls.icon);
        } else {
            icon = new cc.Sprite(bundles[location.getIconBundle(location.getStage())].urls.icon);
        }

        const iconBg = this.createIconBg(icon, isNext);

        const node = new cc.Node();
        node.setAnchorPoint(0.5, 0.5);
        node.setContentSize2(iconBg.getContentSize());
        node.addChild(icon);
        node.addChild(iconBg);
        node.setLocalZOrder(10);

        icon.setAlignment(node.width / 2, node.height / 2);

        return node;
    },

    createLock: function () {
        const styles = cleverapps.styles.ProgressView;

        const lock = new cc.Sprite(bundles.simple.frames.lock_png);
        lock.setLocalZOrder(10);
        lock.setScale(styles.comingSoon.lock.scale);
        lock.setAlignment(styles.comingSoon.lock);

        return lock;
    },

    createIconBg: function (icon, isNext) {
        let styles = cleverapps.styles.ProgressView.icon.bg;

        const iconBg = new cc.Scale9Sprite(isNext ? bundles.simple.frames.frame_next_png || bundles.simple.frames.frame_silver_png : bundles.simple.frames.frame_current_png || bundles.simple.frames.frame_gold_png);

        if (styles.flipped) {
            styles = styles.flipped;

            if (isNext) {
                iconBg.setScaleX(-1);
            }
            iconBg.setAlignment(isNext ? styles.right : styles.left);
        } else {
            iconBg.setContentSize2(icon.width * icon.scaleX + 2 * styles.padding.x, icon.height * icon.scaleY + 2 * styles.padding.y);
            iconBg.setAlignment(styles);
        }

        return iconBg;
    }
});

cleverapps.styles.ProgressView = {
    x: { align: "center" },
    y: { align: "bottom", dy: 250 },

    bar: {
        width: 350,

        spark: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 0 }
        }
    },

    star: {
        x: 0,
        y: -12
    },

    arrows: {
        x: { align: "center" },
        y: { align: "center", dy: 4 },
        widthOffset: 40,
        margin: 15
    },

    icon: {
        offset: {
            y: 6,
            x: 52
        },
        bg: {
            padding: {
                x: 11,
                y: 12
            },
            x: { align: "center" },
            y: { align: "center", dy: -2 }
        }
    },

    comingSoon: {
        lock: {
            x: { align: "center" },
            y: { align: "center" },
            scale: 0.3
        },
        icon: {
            width: 96,
            height: 92
        }
    },

    delta: {
        x: { align: "center" },
        y: { align: "top", dy: 50 }
    }
};
